var map = {
	"./Bingo_popup.png": 683,
	"./Election.png": 684,
	"./Halloween_logo.png": 685,
	"./Holiday_popup.png": 686,
	"./PlinkoPopup.png": 687,
	"./RCR-pop-up.png": 688,
	"./RESTORE-4th-of-July.png": 689,
	"./RESTORE-Logo.png": 177,
	"./RestoreTogetherPopup.png": 690,
	"./Restore_Halloween_Logo.svg": 691,
	"./Superbowl_popup.png": 692,
	"./Thanksgiving_popup.png": 693,
	"./Valentines_popup.png": 694,
	"./Welcome_popup.png": 695,
	"./bens_face.png": 696,
	"./bingo_fun_in_the_sun.png": 697,
	"./default.png": 698,
	"./functional_skills_pop-up.png": 699,
	"./golf_masters_popup.png": 700,
	"./logo.png": 701,
	"./st_patrick_game_pop_up.png": 702,
	"./timocco.svg": 703,
	"./world_cup_banner.png": 344
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 682;


//////////////////
// WEBPACK FOOTER
// ./src/images nonrecursive \.(png|jpe?g|svg)$
// module id = 682
// module chunks = 0